var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "otp-verification-form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "otp-illustration" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "48",
              height: "48",
              viewBox: "0 0 24 24",
              fill: "none"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "3",
                y: "2",
                width: "18",
                height: "20",
                rx: "2",
                fill: "#e6f7fa"
              }
            }),
            _c("rect", {
              attrs: {
                x: "7",
                y: "6",
                width: "10",
                height: "2",
                rx: "1",
                fill: "#4fd1c5"
              }
            }),
            _c("circle", {
              attrs: { cx: "12", cy: "17", r: "1", fill: "#4fd1c5" }
            })
          ]
        )
      ]),
      _c("h2", { staticClass: "otp-title" }, [_vm._v("אימות קוד")]),
      _c("div", { staticClass: "otp-subtitle" }, [
        _vm._v("קוד אימות נשלח בדוא״ל. יש להזין את הקוד כדי להמשיך.")
      ]),
      _c(
        "div",
        { staticClass: "otp-input-group" },
        _vm._l(_vm.digits, function(digit, idx) {
          return _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.digits[idx],
                expression: "digits[idx]"
              }
            ],
            key: idx,
            ref: "otpInput",
            refInFor: true,
            staticClass: "otp-input",
            attrs: {
              type: "text",
              inputmode: "numeric",
              maxlength: "1",
              autocomplete: "one-time-code"
            },
            domProps: { value: _vm.digits[idx] },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.digits, idx, $event.target.value)
                },
                function($event) {
                  return _vm.onDigitInput(idx, $event)
                }
              ],
              keydown: function($event) {
                return _vm.onDigitKeydown(idx, $event)
              },
              paste: _vm.onPaste
            }
          })
        }),
        0
      ),
      _vm.invalidOTP
        ? _c(
            "b-message",
            { staticClass: "otp-error", attrs: { type: "is-danger" } },
            [_vm._v(" קוד האימות שגוי. יש לנסות שוב. ")]
          )
        : _vm._e(),
      _c(
        "b-button",
        {
          attrs: {
            disabled: !_vm.isComplete,
            "native-type": "submit",
            type: "is-primary"
          }
        },
        [_vm._v(" אימות קוד ")]
      ),
      _c(
        "div",
        { staticClass: "otp-resend" },
        [
          _c("span", [_vm._v("הקוד לא הגיע?")]),
          _c(
            "b-button",
            {
              attrs: { type: "is-text", disabled: _vm.resendCooldown > 0 },
              on: { click: _vm.onResend }
            },
            [
              _c("span", [_vm._v("שליחה מחדש")]),
              _vm.resendCooldown > 0
                ? _c("span", [
                    _vm._v(" (" + _vm._s(_vm.resendCooldown) + " שניות)")
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }